import { ActionsMenuOption } from '@fox/atoms/src/action-menu/index';
import { FilterPopover } from '../../grid-toolbar/filter/filter-popover';
import { useAutoDataGridContext } from '../context';
import { GraphColumn } from '../types';
import { applyFilterAction, applyHideAction, pinAction, sortAction } from './column-menu-options';
import { SortPopover } from './sort-popover';

export function defaultColumnActionMenu<T extends Record<string, unknown>>(col: GraphColumn<T>, hideToolbar?: boolean): ActionsMenuOption[] {
	const context = useAutoDataGridContext();

	if (!context) {
		throw new Error('defaultColumnActionMenu must be used within AutoDataGridContext');
	}

	const { pinnedColumnsDataIndex, setPinnedColumnsDataIndex, hiddenColumnsDataIndex, setHiddenColumnsDataIndex } = context;

	const isPinned = pinnedColumnsDataIndex.includes(col.dataIndex);

	const menuOptions: ActionsMenuOption[] = [];

	const pinFunction = () => {
		setPinnedColumnsDataIndex([
			...(isPinned ? [...pinnedColumnsDataIndex.filter(index => index !== col.dataIndex)] : [...pinnedColumnsDataIndex, col.dataIndex])
		]);
	};
	const hideFunction = () => setHiddenColumnsDataIndex([...hiddenColumnsDataIndex, col.dataIndex]);

	const sortOption = sortAction(<SortPopover col={col} />);
	const filterOption = applyFilterAction(<FilterPopover columns={col} />);
	const hideOption = applyHideAction(hideFunction);
	const pinOption = pinAction(pinFunction);

	if (col.sortable && !hideToolbar) {
		menuOptions.push(sortOption);
	}

	if (col.filterType !== undefined && !hideToolbar) menuOptions.push(filterOption);

	menuOptions.push(pinOption);

	if (typeof col.hideable !== 'boolean' || col.hideable) menuOptions.push(hideOption);

	return menuOptions;
}
